<template>
	<section class="other_page_banner qr_sec banner_nxt_sec_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-7 order-2 order-md-1">
					<div class="ban_lt">
						<h5>
							<span>
								{{ $t('new_ui.personal_qr_page.section_banner.title.one') }}
							</span>
							{{ $t('new_ui.personal_qr_page.section_banner.title.two') }}
						</h5>
						<h2>
							{{ $t('new_ui.personal_qr_page.section_banner.main_title.one') }}
						</h2>
						<h6>
							{{ $t('new_ui.personal_qr_page.section_banner.sub_title.one') }}
							<span>
								{{ $t('new_ui.personal_qr_page.section_banner.sub_title.two') }}
							</span>
						</h6>
						<p>
							{{ $t('new_ui.personal_qr_page.section_banner.paragraph.one') }}
							{{ $t('new_ui.personal_qr_page.section_banner.paragraph.two') }}
						</p>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center p-top"
						></div>
					</div>
				</div>
				<div class="col-sm-5 order-1 order-md-2">
					<div class="ban_rt">
						<img :src="img.image32" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="qrpay">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-3 col-xl-3 col-lg-3 col-md-12">
					<div class="qrpay_lt">
						<img :src="img.image33" alt="Logo" />
					</div>
				</div>
				<div class="col-sm-12 col-xxl-9 col-xl-9 col-lg-9 col-md-12">
					<div class="qrpay_rt send_qrpay">
						<span>{{ $t('new_ui.personal_qr_page.qr_pay.label') }}</span>
						<div class="qrpay_rt_txt">
							<h4>
								<span>
									{{ $t('new_ui.personal_qr_page.qr_pay.title.one') }}
								</span>
								{{ $t('new_ui.personal_qr_page.qr_pay.title.two') }}
							</h4>
							<p>
								{{ $t('new_ui.personal_qr_page.qr_pay.paragraph') }}
							</p>
						</div>
						<div class="enjoy_shopping_sec qr-send_desk">
							<div class="enjoy_shopping_inn">
								<div class="enjoy_shopping_box">
									<img :src="img.image2" alt="" />
									<div class="offer_round">1</div>
								</div>
								<div class="enjoy_shopping_dwn">
									<h6>
										{{
											$t('new_ui.personal_qr_page.qr_pay.white_box_1st.heading')
										}}
									</h6>
									<p>
										{{
											$t(
												'new_ui.personal_qr_page.qr_pay.white_box_1st.paragraph',
											)
										}}
									</p>
								</div>
							</div>
							<div class="enjoy_shopping_inn shoping_mid">
								<div class="enjoy_shopping_box">
									<img :src="img.image34" alt="" />
									<div class="offer_round offer_round2">2</div>
								</div>
								<div class="enjoy_shopping_dwn">
									<h6>
										{{
											$t('new_ui.personal_qr_page.qr_pay.white_box_2nd.heading')
										}}
									</h6>
									<p>
										{{
											$t(
												'new_ui.personal_qr_page.qr_pay.white_box_2nd.paragraph',
											)
										}}
									</p>
								</div>
							</div>
							<div class="enjoy_shopping_inn">
								<div class="enjoy_shopping_box">
									<img :src="img.image35" alt="" />
									<div class="offer_round">3</div>
								</div>
								<div class="enjoy_shopping_dwn">
									<h6>
										{{
											$t('new_ui.personal_qr_page.qr_pay.white_box_3rd.heading')
										}}
									</h6>
									<p>
										{{
											$t(
												'new_ui.personal_qr_page.qr_pay.white_box_3rd.paragraph',
											)
										}}
									</p>
								</div>
							</div>
						</div>
					</div>

					<div class="enjoy_shopping_sec qr-send_mob text-center">
						<div class="enjoy_slider">
							<swiper
								:slides-per-view="1"
								:space-between="30"
								:loop="true"
								:pagination="{
									el: '.swiper-pagination-2',
									clickable: true,
								}"
								:autoplay="{ delay: 2000, disableOnInteraction: false }"
								:breakpoints="{
									0: { slidesPerView: 1 },
									600: { slidesPerView: 1.5 },
									768: { slidesPerView: 2 },
									1000: { slidesPerView: 3 },
									1200: { slidesPerView: 4.5 },
								}"
							>
								<swiper-slide>
									<div class="enjoy_shopping_inn">
										<div class="enjoy_shopping_box">
											<img :src="img.image2" alt="" />
											<div class="offer_round">1</div>
										</div>
										<div class="enjoy_shopping_dwn">
											<h6>
												{{
													$t(
														'new_ui.personal_qr_page.qr_pay.white_box_1st.heading',
													)
												}}
											</h6>
											<p>
												{{
													$t(
														'new_ui.personal_qr_page.qr_pay.white_box_1st.paragraph',
													)
												}}
											</p>
										</div>
									</div>
								</swiper-slide>
								<swiper-slide>
									<div class="enjoy_shopping_inn">
										<div class="enjoy_shopping_box">
											<img :src="img.image34" alt="" />
											<div class="offer_round offer_round2">2</div>
										</div>
										<div class="enjoy_shopping_dwn">
											<h6>
												{{
													$t(
														'new_ui.personal_qr_page.qr_pay.white_box_2nd.heading',
													)
												}}
											</h6>
											<p>
												{{
													$t(
														'new_ui.personal_qr_page.qr_pay.white_box_2nd.paragraph',
													)
												}}
											</p>
										</div>
									</div>
								</swiper-slide>
								<swiper-slide>
									<div class="enjoy_shopping_inn">
										<div class="enjoy_shopping_box">
											<img :src="img.image35" alt="" />
											<div class="offer_round">3</div>
										</div>
										<div class="enjoy_shopping_dwn">
											<h6>
												{{
													$t(
														'new_ui.personal_qr_page.qr_pay.white_box_3rd.heading',
													)
												}}
											</h6>
											<p>
												{{
													$t(
														'new_ui.personal_qr_page.qr_pay.white_box_3rd.paragraph',
													)
												}}
											</p>
										</div>
									</div>
								</swiper-slide>
							</swiper>
							<!-- Move pagination outside swiper -->
							<div class="swiper-pagination-2"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="future_currency_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12">
					<div class="future_currency_inn">
						<span>{{
							$t('new_ui.personal_qr_page.future_currency_sec.label')
						}}</span>
						<h3>
							{{ $t('new_ui.personal_qr_page.future_currency_sec.title.one')
							}}<span>
								{{
									$t('new_ui.personal_qr_page.future_currency_sec.title.two')
								}}
							</span>
							{{
								$t('new_ui.personal_qr_page.future_currency_sec.title.three')
							}}
						</h3>
					</div>
				</div>
			</div>
			<div class="row safety_desk">
				<div class="col-sm-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6">
					<div class="banner_panel">
						<h6>
							{{
								$t(
									'new_ui.personal_qr_page.future_currency_sec.future_white_box_1st.heading',
								)
							}}
						</h6>
						<div class="banner_panel_dwn">
							<div class="banner_panel_dwn_lt">
								<img :src="img.image2" alt="Logo" />
							</div>
							<div class="banner_panel_dwn_rt">
								<p>
									{{
										$t(
											'new_ui.personal_qr_page.future_currency_sec.future_white_box_1st.paragraph',
										)
									}}
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6">
					<div class="banner_panel">
						<h6>
							{{
								$t(
									'new_ui.personal_qr_page.future_currency_sec.future_white_box_2nd.heading',
								)
							}}
						</h6>
						<div class="banner_panel_dwn">
							<div class="banner_panel_dwn_lt">
								<img :src="img.image3" alt="Logo" />
							</div>
							<div class="banner_panel_dwn_rt">
								<p>
									{{
										$t(
											'new_ui.personal_qr_page.future_currency_sec.future_white_box_2nd.paragraph',
										)
									}}
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6">
					<div class="banner_panel">
						<h6>
							{{
								$t(
									'new_ui.personal_qr_page.future_currency_sec.future_white_box_3rd.heading',
								)
							}}
						</h6>
						<div class="banner_panel_dwn">
							<div class="banner_panel_dwn_lt">
								<img :src="img.image4" alt="Logo" />
							</div>
							<div class="banner_panel_dwn_rt">
								<p>
									{{
										$t(
											'new_ui.personal_qr_page.future_currency_sec.future_white_box_3rd.paragraph',
										)
									}}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="safety_speed_mob">
		<div class="container">
			<div class="row">
				<div class="col-sm-12">
					<div class="safety_slider">
						<swiper
							:slides-per-view="1"
							:space-between="30"
							:loop="true"
							:pagination="{
								el: '.swiper-pagination-1',
								clickable: true,
							}"
							:autoplay="{ delay: 2000, disableOnInteraction: false }"
							:breakpoints="{
								0: { slidesPerView: 1 },
								600: { slidesPerView: 1.5 },
								768: { slidesPerView: 2 },
								1000: { slidesPerView: 3 },
								1200: { slidesPerView: 4.5 },
							}"
						>
							<swiper-slide>
								<div class="banner_panel">
									<h6>
										{{
											$t(
												'new_ui.personal_qr_page.future_currency_sec.future_white_box_1st.heading',
											)
										}}
									</h6>
									<div class="banner_panel_dwn">
										<div class="banner_panel_dwn_lt">
											<img :src="img.image2" alt="Logo" />
										</div>
										<div class="banner_panel_dwn_rt">
											<p>
												{{
													$t(
														'new_ui.personal_qr_page.future_currency_sec.future_white_box_1st.paragraph',
													)
												}}
											</p>
										</div>
									</div>
								</div>
							</swiper-slide>
							<swiper-slide>
								<div class="banner_panel">
									<h6>
										{{
											$t(
												'new_ui.personal_qr_page.future_currency_sec.future_white_box_2nd.heading',
											)
										}}
									</h6>
									<div class="banner_panel_dwn">
										<div class="banner_panel_dwn_lt">
											<img :src="img.image3" alt="Logo" />
										</div>
										<div class="banner_panel_dwn_rt">
											<p>
												{{
													$t(
														'new_ui.personal_qr_page.future_currency_sec.future_white_box_2nd.paragraph',
													)
												}}
											</p>
										</div>
									</div>
								</div>
							</swiper-slide>
							<swiper-slide>
								<div class="banner_panel">
									<h6>
										{{
											$t(
												'new_ui.personal_qr_page.future_currency_sec.future_white_box_3rd.heading',
											)
										}}
									</h6>
									<div class="banner_panel_dwn">
										<div class="banner_panel_dwn_lt">
											<img :src="img.image4" alt="Logo" />
										</div>
										<div class="banner_panel_dwn_rt">
											<p>
												{{
													$t(
														'new_ui.personal_qr_page.future_currency_sec.future_white_box_3rd.paragraph',
													)
												}}
											</p>
										</div>
									</div>
								</div>
							</swiper-slide>
						</swiper>
						<!-- Move pagination outside swiper -->
						<div class="swiper-pagination-1"></div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="online_mid">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 border_dash">
					<div class="row">
						<div class="col-sm-6">
							<div class="business_anywhere_lt">
								<span>
									{{ $t('new_ui.personal_qr_page.online_mid.label') }}
								</span>
								<div class="business_anywhere_txt">
									<h4>
										{{ $t('new_ui.personal_qr_page.online_mid.title.one') }}
										<span>
											{{ $t('new_ui.personal_qr_page.online_mid.title.two') }}
										</span>
										{{ $t('new_ui.personal_qr_page.online_mid.title.three') }}
									</h4>
									<p>
										{{ $t('new_ui.personal_qr_page.online_mid.paragraph.one') }}
									</p>
									<div class="starting_to_btn">
										<a href="/auth/register">
											{{
												$t('new_ui.personal_qr_page.online_mid.cta_buttons.one')
											}}
										</a>
									</div>
								</div>
							</div>
						</div>
						<div class="col-sm-6">
							<div class="business_anywhere_rt">
								<img :src="img.image36" alt="" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t(
								'new_ui.personal_online_shopping_page.section_newsletter.label',
							)
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t(
										'new_ui.personal_online_shopping_page.section_newsletter.title.one',
									)
								}}</span>
								{{
									$t(
										'new_ui.personal_online_shopping_page.section_newsletter.title.two',
									)
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.personal_online_shopping_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.personal_online_shopping_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.personal_online_shopping_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.personal_online_shopping_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import secure from '@/assets/images/sub/Secure Payment.png';
import anycompany from '@/assets/images/sub/Any Company.png';
import touch from '@/assets/images/sub/Touch Free.png';
import paywith from '@/assets/images/sub/Pay With Us.png';
import curveup from '@/assets/images/sub/Curve Arrow.png';
import curvedwn from '@/assets/images/sub/Curve_dwn.png';
import customer from '@/assets/images/sub/Total Customers.png';
import satisfaction from '@/assets/images/sub/satisfaction.png';
import money from '@/assets/images/sub/money.png';
import handmob from '@/assets/images/sub/handmob.png';
import choose from '@/assets/images/sub/Choose.png';
import securepayment from '@/assets/images/sub/Secure Payment.png';
import seller from '@/assets/images/sub/seller.png';
import manqr from '@/assets/images/sub/manqr.png';
import qrmob from '@/assets/images/sub/qrmob.png';
import handmobile from '@/assets/images/sub/handmobile.png';
import confirm from '@/assets/images/sub/Confirm.png';
import manqrphone from '@/assets/images/sub/manqrphn.png';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
SwiperCore.use([Autoplay, Pagination]);
export default {
	data: () => {
		return {
			img: {
				image2: secure,
				image3: anycompany,
				image4: touch,
				image11: paywith,
				image12: curveup,
				image13: curvedwn,
				image23: customer,
				image24: satisfaction,
				image25: money,
				image27: handmob,
				image29: choose,
				image30: securepayment,
				image31: seller,
				image32: manqr,
				image33: qrmob,
				image34: handmobile,
				image35: confirm,
				image36: manqrphone,
			},
		};
	},
};
</script>
